/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {toAbsoluteUrl} from '../../../helpers'

type Props = {
  className: string
  title: string
  description: string
  image: string
  image2?: string
}

const CardSystemWidget2: React.FC<Props> = ({className, title, description, image, image2}) => {
  const [imagem, setImagem] = useState(image)
  function MouseOver() {}

  function MouseOut() {
    setImagem(image)
  }
  // border-hover-verde-claro
  return (
    <div
      className={`card ${className} 
          border          
          border-gray-300
          hoverable
          bg-hover-light-primary        
          text-hover-primary          
          `}
      onMouseOver={MouseOver}
      onMouseOut={MouseOut}
    >
      {/* begin::Body */}
      <div className='card-body d-flex align-items-center pt-3 pb-0'>
        <div className='d-flex flex-column flex-grow-1 py-2 py-lg-10 me-2'>
          <p className='fw-bolder text-primary fs-4 mb-2 '>{title}</p>

          <span className='fw-bold  fs-1rem' dangerouslySetInnerHTML={{__html: description}}></span>
        </div>

        <img
          src={toAbsoluteUrl(imagem)}
          alt=''
          // className='align-self-center col-2 col-sm-3 col-lg-4 col-xl-5 col-xxl-3'
          width={'25%'}
        />
      </div>
      {/* end::Body */}
    </div>
  )
}

export {CardSystemWidget2}
